import { AslibModalComponent, AslibModalService } from '@aslib/modal';
/*
  Desenvolvido por: Ayslan Johnson
  Data: 10/04/2018
  Objetivo: Tratar mensagens de erro para todas as chamadas de Serviço
*/
import { Response } from '@angular/http';
import { Inject, forwardRef } from '@angular/core';

export class GenericMessageService {
  private readonly aslibModal: AslibModalComponent;

  constructor(
    @Inject(forwardRef(() => AslibModalService))
    private readonly aslibModalService: AslibModalService
  ) {
    this.aslibModal = new AslibModalComponent(this.aslibModalService);
  }

  throw(error: Response) {
    if (error.status === 0) {
      this.aslibModal.open({
        title: '404: URL Não encontrada',
        text: `Não foi possível realizar a comunicação com o serviço.`,
        type: 'danger',
        backdrop: 'static'
      });
    } else {
      if (error.status > 0) {
        this.aslibModal.open({
          title: 'Erro do Sistema',
          text: `Código: [${error.status}]. Erro: ${error.statusText}`,
          type: 'danger',
          backdrop: 'static'
        });
      } else {
        this.message(
          'Erro do sistema',
          'Entre em contato com o Administrador. Tente novamente mais tarde',
          'error'
        );
      }
    }
  }

  message(
    title: string,
    text: string,
    type: string
  ) {
    type = type === 'error' ? 'danger' : type;

    this.aslibModal.open({
      title: title,
      text: text,
      type: type,
      backdrop: 'static'
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/generic-message.service.ts